import AllTextState from "./assets/shared/state/AllTextState"
import { RoutePaths } from "./routes/RoutePaths"

const menuItemsTypes = {
  dashboard: {
    id: AllTextState.dashboard,
    title: AllTextState.dashboard,
    type: "item",
    url: RoutePaths.DASHBOARD,
    classes: "nav-item",
    icon: "PieChart"
  },
  userManagement: {
    id: AllTextState.userManag,
    title: AllTextState.userManag,
    type: "item",
    url: RoutePaths.USERS,
    classes: "nav-item",
    icon: "Users"
  },
  tenantManagement: {
    id: AllTextState.tenant,
    title: AllTextState.tenantManagement,
    type: "item",
    url: RoutePaths.TENANTS,
    classes: "nav-item",
    icon: "Home"
  },
  tenantImageManagement: {
    id: AllTextState.tenant,
    title: AllTextState.tenantImage,
    type: "item",
    url: RoutePaths.TENANT_IMAGE,
    classes: "nav-item",
    icon: "Home"
  },
  appointments: {
    id: AllTextState.appointment,
    title: AllTextState.appointment,
    type: "item",
    url: RoutePaths.APPOINTMENTS,
    classes: "nav-item",
    icon: "Calendar",
    count: 0
  },
  clubManagement: {
    id: AllTextState.clubManagement,
    title: AllTextState.clubManagement,
    type: "item",
    url: RoutePaths.ORGANIZATIONS,
    classes: "nav-item",
    icon: "Layers"
  },
  claimManagement: {
    id: 'Claim Management',
    title: 'Claim Management',
    type: "item",
    url: RoutePaths.USE_CASE_CLAIMS,
    classes: "nav-item",
    icon: "File",
  },
  caseManagement: {
    id: 'Case Management',
    title: 'Case Management',
    type: "item",
    url: RoutePaths.USE_CASE_CASES,
    classes: "nav-item",
    icon: "File",
  },
  chats: {
    id: AllTextState.chat,
    title: AllTextState.chat,
    type: "item",
    url: RoutePaths.CHATS,
    classes: "nav-item",
    icon: "MessageCircle"
  },
  recoveryProgresses: {
    id: AllTextState.recoveryProgress,
    title: AllTextState.recoveryProgress,
    type: "item",
    url: RoutePaths.RECOVERY_PROGRESSES,
    classes: "nav-item",
    icon: "Layers"
  },
  recoveryProgress: {
    id: AllTextState.recoveryProgress,
    title: AllTextState.recoveryProgress,
    type: "item",
    url: RoutePaths.RECOVERY_PROGRESS,
    classes: "nav-item",
    icon: "Layers"
  },
  reports: {
    id: AllTextState.report,
    title: AllTextState.report,
    type: "item",
    url: RoutePaths.REPORT,
    classes: "nav-item",
    icon: "ReportsIcon"
  }
}

// Initialize the menuItems object without circular references
const menuItems = {
  superAdmin: [
    menuItemsTypes.dashboard,
    menuItemsTypes.userManagement,
    menuItemsTypes.tenantManagement,
    menuItemsTypes.reports
  ],
  tenantAdmin: [
    menuItemsTypes.dashboard,
    menuItemsTypes.tenantImageManagement,
    menuItemsTypes.userManagement,
    menuItemsTypes.clubManagement,
    menuItemsTypes.reports,
    {
      id: AllTextState.survey,
      title: AllTextState.surveyTitle,
      type: "collapse",
      icon: "BarChart2",
      children: [
        {
          id: AllTextState.summary,
          title: AllTextState.summary,
          type: "item",
          url: RoutePaths.SURVEY_DASHBOARD,
          classes: "nav-item",
          icon: "PieChart"
        },
        {
          id: AllTextState.questionnaire,
          title: AllTextState.questions,
          type: "item",
          url: RoutePaths.SURVEY_QUESTIONNAIRES,
          classes: "nav-item",
          icon: "HelpCircle"
        },
        {
          id: AllTextState.surveyEvent,
          title: AllTextState.surveyEvent,
          type: "item",
          url: RoutePaths.SURVEY_EVENTS,
          classes: "nav-item",
          icon: "Calendar"
        },
        {
          id: AllTextState.report,
          title: AllTextState.report,
          type: "item",
          url: RoutePaths.SURVEY_REPORT,
          classes: "nav-item",
          icon: "ReportsIcon"
        }
      ]
    }
  ],
  claimManager: [
    menuItemsTypes.dashboard,
    menuItemsTypes.appointments,
    menuItemsTypes.userManagement,
    menuItemsTypes.claimManagement,
    menuItemsTypes.caseManagement,
    menuItemsTypes.recoveryProgresses,
    menuItemsTypes.chats,
    menuItemsTypes.reports
  ],
  claimant: [
    menuItemsTypes.dashboard,
    menuItemsTypes.appointments,
    menuItemsTypes.claimManagement,
    menuItemsTypes.caseManagement,
    menuItemsTypes.recoveryProgress,
    menuItemsTypes.chats,
    menuItemsTypes.reports,
    {
      id: AllTextState.survey,
      title: AllTextState.surveyTitle,
      type: "item",
      url: RoutePaths.SURVEY_PROCESS,
      classes: "nav-item",
      icon: "ReportsIcon"
    }
  ],
  orgAdmin: [
    menuItemsTypes.dashboard,
    menuItemsTypes.appointments,
    menuItemsTypes.claimManagement,
    menuItemsTypes.caseManagement,
    menuItemsTypes.userManagement,
    menuItemsTypes.chats,
    menuItemsTypes.reports
  ],
  rehabManager: [
    menuItemsTypes.dashboard,
    menuItemsTypes.appointments,
    menuItemsTypes.claimManagement,
    menuItemsTypes.chats,
    menuItemsTypes.reports
  ]
}

// Export menuItems after it's fully initialized
export default menuItems
